import React from 'react';
import { faThumbtack as faOutlineThumbtack } from '@fortawesome/pro-regular-svg-icons/faThumbtack';
import { faThumbtack } from '@fortawesome/pro-solid-svg-icons/faThumbtack.js';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as PropTypes from 'prop-types';

import Box from 'components/Box';
import Button from 'components/clickables/Button';
import Text from 'components/Text';

const PinnedToggle = ({ pinned, onClick }) => {
  const faIcon = pinned ? faThumbtack : faOutlineThumbtack;
  const theme = pinned ? 'primary' : 'secondary-blue';
  const text = pinned
    ? 'message_drawer.team_emails.pinned'
    : 'message_drawer.team_emails.pin';

  return (
    <Box w={96}>
      <Button theme={theme} onClick={onClick} fullWidth size="small">
        <FontAwesomeIcon icon={faIcon} />
        &nbsp;&nbsp;
        <Text i18n={text} />
      </Button>
    </Box>
  );
};

PinnedToggle.propTypes = {
  onClick: PropTypes.func.isRequired,
  pinned: PropTypes.bool.isRequired,
};

export default PinnedToggle;
